import Listing from './Lisiting';

export default Listing;
